import { stringify } from 'qs'

import { lsGet, safeAwait } from 'utils/request'

export const getVenderCount = (props) => {
  return safeAwait(
    lsGet(
      `/venders/count?${stringify({ ...props, isFilterListVisible: true })}`
    )
  )
}
